const getOccupancyData = state => state.occupancyData;

export default { getOccupancyData };
